//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapActions } from 'vuex';
import constant from '~/const';

export default {
  props: {
    isLoading: { type: Boolean, default: false },
  },

  data() {
    return {
      filters: {
        text: null,
        dateCreatedFrom: null,
        dateCreatedTo: null,
      },
      constant,
    };
  },

  computed: {
    ...mapState('userP2PReviews', ['filterLists']),
  },

  watch: {
    filters: {
      async handler(data) {
        await this.setFilters(data);
        this.$emit('update');
      },
      deep: true,
    },
  },

  methods: {
    ...mapActions('userP2PReviews', ['setFilters']),
  },
};
